<map-header></map-header>
<ion-content>
    <map-fab-view></map-fab-view>
</ion-content>
